import React from 'react';

/**
 * Composant Avatar réutilisable
 * Affiche la photo de profil d'un utilisateur ou un placeholder
 */
export default function Avatar({ 
    user, 
    size = 'md', // 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    className = '',
    showName = false 
}) {
    const sizeClasses = {
        xs: 'w-6 h-6 text-xs',
        sm: 'w-8 h-8 text-sm',
        md: 'w-10 h-10 text-base',
        lg: 'w-12 h-12 text-lg',
        xl: 'w-16 h-16 text-2xl'
    };

    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <div className={`${sizeClasses[size]} rounded-full overflow-hidden flex-shrink-0 ring-2 ring-gray-700/30`}>
                {user?.avatar ? (
                    <img 
                        src={user.avatar}
                        alt={user.username || 'Avatar'}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            // Fallback en cas d'erreur de chargement
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                ) : null}
                <div 
                    className={`w-full h-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-gray-900 font-bold ${user?.avatar ? 'hidden' : 'flex'}`}
                    style={{ display: user?.avatar ? 'none' : 'flex' }}
                >
                    {getInitials(user?.username || user?.email || '?')}
                </div>
            </div>
            
            {showName && user?.username && (
                <span className="text-sm font-medium text-gray-300">
                    {user.username}
                </span>
            )}
        </div>
    );
}
